import React from 'react'
import { Card, CardBody } from 'reactstrap'
import TableItems from './ListItemsTable/TableItems'
import { getListBarcodeV41, countPendingRegenerateLabel, getQcReport } from '../../services/api/apiBarcode'
import { _convertObject } from "../helpers/convertObject"
import Loading from '../../components/Loading/Loading'
import ListItemsFooter from './ListItemsFooter'
import ListItemsFilter from './ListItemsFilter'
import ListItemsOverview from './ListItemsOverview'
import ModalEditItem from './SingleAction/ModalEditItem'
import ModalEditProduct from './SingleAction/ModalEditProduct'
import ListItemsCardHeader from './ListItemsCardHeader'
import queryString from 'query-string'
import ModalMarkFailedDesign from './SingleAction/ModalMarkFailedDesign'
import { getListRequests } from "../../services/api/RequestsService"
import ModalItemLabel from "./SingleAction/ModalItemLabel"
import moment from 'moment'
import ModalGenLabelCustomWHL from './SingleAction/ModalGenLabelCustomWHL'
import { message } from 'antd'

class ListItemsPage extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            error: '',
            sort: '',
            loading: false,
            isLoading: true,
            itemEdit: null,
            productEdit: null,
            faileDesign: null,
            prev: null,
            next: null,
            allSelected: false,
            selectedItems: {},
            items: [],
            pagination: {
                limit: 500,
                total: 0,
            },
            filter: {
                hide_archived: 'hide_archived',
                production_status: ['pending', 'in_production', 'labelled'],
                created: {},
                generated: {},
                barcodeNumber: {},
                product_types_mode: 'in',
                storename: []
            },
            itemsRequest: [],
            imageItemLabel: null,
            currentPage: 1,
            itemGenLabelCustomWHL: null,
            dataQcReport: {},
            isShowQcReport: false,
        }
    }

    timeoutFilter = null
    timeoutFetch = null

    _parseFilterFromSearch = (search) => {
        let params = {}

        if (search !== '') {
            const query = queryString.parse(search)
            params = query
            if (query.production_status !== undefined) params.production_status = [query.production_status]
            if (query.is_cheap_product === "true") {
                params.isCheapProduct = "true"
                delete params.is_cheap_product
            }
        }

        return params
    }

    componentDidMount() {
        const { history } = this.props
        const { filter } = this.state
        const { location } = history
        const params = this._parseFilterFromSearch(location.search)
        const lastYear = moment().subtract(365, 'days').format('DD/MM/YYYY')

        this.setState({
            filter: {
                ...filter,
                ...params,
                created: {
                    from: lastYear,
                }
            }
        }, () => {
            this._fetchItems()
        })

        this._fetchPendingRegenerateLabel()
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props

        if (!location || prevProps.location.search === location.search) return

        const { filter } = this.state
        const params = this._parseFilterFromSearch(location.search)
        const lastYear = moment().subtract(365, 'days').format('DD/MM/YYYY')

        this.setState({
            filter: {
                ...filter,
                ...params,
                created: {
                    from: lastYear,
                }
            }
        }, () => {
            this._fetchItems()
        })
    }

    componentWillUnmount() {
        this.timeoutFilter = null
    }

    _handleChangeFilter = (filter, timeOut = 0) => {
        const {dataQcReport = {}} = this.state
        this.setState({ filter }, () => {
            this._reloadItems(timeOut)
        })

        if (!!Object.keys(dataQcReport).length) {
            this.props.history.push({
                pathname: this.props.location.pathname,
                search: ""
            })
        }
    }

    _handleChangeFilterTag = (value, timeOut = 0) => {
        this.setState(preState => ({
            filter: {
                ...preState.filter,
                list_tags: !!preState.filter.list_tags ? (preState.filter.list_tags.includes(value) ? preState.filter.list_tags : [...preState.filter.list_tags, value]) : [value]
            }
        }), () => {
            this._reloadItems(timeOut)
        })
    }

    _fetchItemsRequest = async (items) => {
        try {
            const payload = {
                barcodes: items
            }
            const { success, data, message } = await getListRequests(payload)
            if (!success) throw new Error(message)
            this.setState({
                itemsRequest: data.requests
            })
        } catch (e) {
            alert(e.message)
        }
    }

    _fetchItems = async (newPayload = {}) => {
        const { requestCount } = this.state
        const nextCount = requestCount ? requestCount + 1 : 1

        this.setState({
            loading: true,
            requestCount: nextCount
        })

        try {
            const { pagination, filter, sort: sortProductionTime } = this.state
            const sort = sortProductionTime !== '' ? `max_production_time.${sortProductionTime}` : null
            const newFilters = Object.assign(filter, { sort })
            const cloneFilter = _convertObject(newFilters)

            if (cloneFilter.tags) cloneFilter.tags = [...cloneFilter.tags]
            if (cloneFilter.tags && cloneFilter.list_tags) cloneFilter.tags = [...cloneFilter.tags, ...cloneFilter.list_tags]
            if (cloneFilter.list_tags && !cloneFilter.tags) cloneFilter.tags = cloneFilter.list_tags

            if (cloneFilter.is_fba) {
                if (cloneFilter.is_fba === 'TikTok') {
                    cloneFilter.is_tiktok = 'y'
                    delete cloneFilter.is_fba
                } else if (cloneFilter.is_fba === 'n') {
                    cloneFilter.is_tiktok = 'n'
                }
            }

            if(cloneFilter.photo_requested) cloneFilter.request_photo_statuses = [cloneFilter.photo_requested]
 
            const {list_tags, ...newCloneFilter} = cloneFilter

            const { page, limit } = pagination

            const resRead = !!Object.keys(newPayload).length ? await getListBarcodeV41({ ...newPayload }) : await getListBarcodeV41({ page, limit, ...newCloneFilter })

            const { success, barcodes, message, total, prev, next } = resRead.data

            if (nextCount !== this.state.requestCount) {
                return
            }

            if (!success) {
                throw new Error(message)
            }

            let listBarcodeRequest = []

            barcodes.map(item => {
                const barcode = item.barcodeNumber
                item.products.map(itemP => {
                    (itemP.tags !== undefined && itemP.tags.length > 0 && (itemP.tags.indexOf('waiting-update-design') !== -1 || itemP.tags.indexOf('waiting-update-address') !== -1 || itemP.tags.indexOf('updated') !== -1 || itemP.tags.indexOf('updated-design') !== -1 || itemP.tags.indexOf('forced-updated') !== -1)) && listBarcodeRequest.push(`#${barcode}_${itemP.pos}`)
                })
            })

            this.setState({
                items: barcodes,
                pagination: { ...pagination, total },
                error: '',
                isLoading: false,
                loading: false,
                prev: prev,
                next: next,
                allSelected: false,
                selectedItems: {},
            }, () => {
                if (listBarcodeRequest.length > 0) {
                    this._fetchItemsRequest(listBarcodeRequest)
                }
            })
        } catch (e) {
            alert(e.message)

            this.setState({
                error: '',
                isLoading: false,
                loading: false,
                prev: null,
                next: null
            })
        }
    }

    _fetchPendingRegenerateLabel = async () => {
        try {
            const { data: response } = await countPendingRegenerateLabel()
            const { success, data = {}, message: mess } = response

            if (!success) throw new Error(mess)
            const { count = 0, params = {} } = {...data}

            if(count > 0){
                this.setState({
                    countPendingRegenerateLabel: count,
                    paramsPendingRegenerateLabel: params,
                })
            }

        } catch (e) {
            message.error(e.message)
        }
    }

    _reloadItems = (ms = 0) => {
        if (this.timeoutFetch) clearTimeout(this.timeoutFetch)

        this.timeoutFetch = setTimeout(() => this._fetchItems(), ms)
    }

    _handleChangePage = (paging) => {
        this.setState(({ pagination }) => ({
            pagination: {
                ...pagination,
                ...paging
            }
        }), () => {
            this._reloadItems(500)
        })
    }

    _openModalEdit = (item) => {
        this.setState({ itemEdit: item })
    }

    _closeModalEdit = () => {
        this.setState({ itemEdit: null })
    }

    _renderModalEdit = () => {
        const { itemEdit } = this.state

        if (itemEdit) {
            return (
                <ModalEditItem
                    isOpen={null !== itemEdit}
                    item={itemEdit}
                    className="EditAddress"
                    toggle={this._closeModalEdit}
                    reload={this._reloadItems}
                />
            )
        }

        return false
    }

    _openModalEditProduct = (item) => {
        this.setState({ productEdit: item })
    }

    _closeModalEditProduct = () => {
        this.setState({ productEdit: null })
    }

    _openModalMarkFaileDesign = (item) => {
        this.setState({ faileDesign: item })
    }

    _closeModalMarkFaileDesign = () => {
        this.setState({ faileDesign: null })
    }

    _renderModalMarkFaileDesign = () => {
        const { faileDesign } = this.state
        if (faileDesign) {
            return (
                <ModalMarkFailedDesign
                    className="ModalMarkFailedDesign"
                    isOpen={faileDesign !== null}
                    product={faileDesign}
                    toggle={this._closeModalMarkFaileDesign}
                    reload={this._reloadItems}
                />
            )
        }
        return false
    }

    _renderModalEditProduct = () => {
        const { productEdit } = this.state
        if (productEdit) {
            return (
                <ModalEditProduct
                    isOpen={productEdit !== null}
                    product={productEdit}
                    toggle={this._closeModalEditProduct}
                    reload={this._reloadItems}
                />
            )
        }
        return false
    }

    _toggleSelectAll = (e) => {
        const { checked } = e.target

        this.setState(() => {
            if (checked) {
                const { items } = this.state
                const itemsCanChecked = items.filter(item => (item.products.length > 0
                    //  && item.production_status !== 'labelled' && item.production_status !== 'packaged'
                ))

                return {
                    allSelected: true,
                    selectedItems: itemsCanChecked.reduce((pre, order) => Object.assign(pre, { [order._id]: true }), {}),
                }
            }

            return {
                allSelected: false,
                selectedItems: {},
            }
        })
    }

    _handleChangeSelected = (id, isAdded) => {
        const { items } = this.state
        const itemsCanChecked = items.reduce(
            (pre, item) =>
                (item.products.length > 0
                    //  && item.production_status !== 'labelled' && item.production_status !== 'packaged'
                )
                    ? Object.assign(pre, { [item._id]: true }) : pre, {}
        )

        this.setState(({ selectedItems }) => {
            return {
                selectedItems: Object.assign(selectedItems, { [id]: isAdded && itemsCanChecked[id] }),
                allSelected: isAdded ? (Object.values(selectedItems).filter(Boolean).length === Object.values(itemsCanChecked).length) : false
            }
        })
    }

    _resetBulkAll = () => {
        this.setState({
            allSelected: false,
            selectedItems: {},
        })
    }

    _handleChangeSort = (value) => {
        this.setState({
            sort: value
        }, () => {
            this._fetchItems()
        })
    }

    _openModalItemLabel = (image) => {
        this.setState({ imageItemLabel: image })
    }

    _closeModalItemLabel = () => {
        this.setState({ imageItemLabel: null })
    }

    _renderModalItemLabel = () => {
        const { imageItemLabel } = this.state

        if (imageItemLabel) {
            return (
                <ModalItemLabel
                    isOpen={null !== imageItemLabel}
                    itemLabel={imageItemLabel}
                    className="ImageItemLabel"
                    toggle={this._closeModalItemLabel}
                />
            )
        }

        return false
    }

    _handleChangeNextCurrentPage = () => {
        this.setState(({ currentPage }) => ({ currentPage: currentPage + 1 }))
    }

    _handleChangePreCurrentPage = () => {
        this.setState(({ currentPage }) => ({ currentPage: currentPage - 1 }))
    }

    _openModalGenLabelCustomWHL = (item) => {
        this.setState({ itemGenLabelCustomWHL: item })
    }

    _closeModalGenLabelCustomWHL = () => {
        this.setState({ itemGenLabelCustomWHL: null })
    }

    _renderModalGenLabelCustomWHL = () => {
        const { itemGenLabelCustomWHL } = this.state

        if (itemGenLabelCustomWHL) {
            return (
                <ModalGenLabelCustomWHL
                    isOpen={null !== itemGenLabelCustomWHL}
                    item={itemGenLabelCustomWHL}
                    className="EditAddress"
                    toggle={this._closeModalGenLabelCustomWHL}
                    reload={this._reloadItems}
                />
            )
        }

        return false
    }


    _fetchQcReport = async () => {
        this.setState({loading: true})
        try {
            const { filter, sort: sortProductionTime, dataQcReport = {} } = this.state
            if(!!Object.keys(dataQcReport).length){
                return this.setState({isShowQcReport: true})
            }

            const sort = sortProductionTime !== '' ? `max_production_time.${sortProductionTime}` : null
            const newFilters = Object.assign(filter, { sort })
            const cloneFilter = _convertObject(newFilters)

            if (cloneFilter.tags) cloneFilter.tags = [...cloneFilter.tags]
            if (cloneFilter.tags && cloneFilter.list_tags) cloneFilter.tags = [...cloneFilter.tags, ...cloneFilter.list_tags]
            if (cloneFilter.list_tags && !cloneFilter.tags) cloneFilter.tags = cloneFilter.list_tags

            if (cloneFilter.is_fba) {
                if (cloneFilter.is_fba === 'TikTok') {
                    cloneFilter.is_tiktok = 'y'
                    delete cloneFilter.is_fba
                } else if (cloneFilter.is_fba === 'n') {
                    cloneFilter.is_tiktok = 'n'
                }
            }

            const { list_tags, valueOvertime, ...newCloneFilter } = cloneFilter

            const {data: res} = await getQcReport(newCloneFilter)
            const {data, success, message: mess} = res
            if(!success) throw new Error(mess)
            
            this.setState({
                dataQcReport: data,
                isShowQcReport: true,
            })
        } catch (e) {
            alert(e.message)
        }finally{
            this.setState({loading: false})
        }
    }

    render() {
        if (this.state.isLoading) return <Loading />

        const {
            items,
            sort,
            pagination,
            filter,
            loading,
            prev,
            next,
            allSelected,
            selectedItems,
            itemsRequest,
            currentPage,
            countPendingRegenerateLabel,
            paramsPendingRegenerateLabel,
            dataQcReport,
            isShowQcReport,
        } = this.state

        return (
            <div className='ListItemsPage'>
                <Card>
                    <ListItemsCardHeader
                        filter={filter}
                        items={items}
                        reload={this._reloadItems}
                    />
                    <CardBody>
                        <ListItemsOverview items={items} filter={filter} {...this.props} />
                        <ListItemsFilter
                            loading={loading}
                            filter={filter}
                            onChangeFilter={this._handleChangeFilter}
                            countPendingRegenerateLabel={countPendingRegenerateLabel}
                            paramsPendingRegenerateLabel={paramsPendingRegenerateLabel}
                            onFetchQcReport={this._fetchQcReport}
                            isShowQcReport={isShowQcReport}
                            dataQcReport={dataQcReport}
                            onCancelQcReport={() => this.setState({isShowQcReport: false})}
                            {...this.props}
                        />
                        <TableItems
                            loading={loading}
                            items={items}
                            sort={sort}
                            allSelected={allSelected}
                            selectedItems={selectedItems}
                            onChangeSort={this._handleChangeSort}
                            onChangeSelected={this._handleChangeSelected}
                            onResetBulkAll={this._resetBulkAll}
                            onToggleSelectAll={this._toggleSelectAll}
                            onReloadItems={this._reloadItems}
                            onOpenModalEdit={this._openModalEdit}
                            onOpenModalEditProduct={this._openModalEditProduct}
                            openModalMarkFaileDesign={this._openModalMarkFaileDesign}
                            itemsRequest={itemsRequest}
                            onOpenModalItemLabel={this._openModalItemLabel}
                            onChangeFilterTag={this._handleChangeFilterTag}
                            onOpenModalGenLabelCustomWHL={this._openModalGenLabelCustomWHL}
                            filter={filter}
                            onChangeFilter={this._handleChangeFilter}
                        />
                        <ListItemsFooter
                            loading={loading}
                            prev={prev}
                            next={next}
                            pagination={pagination}
                            filter={filter}
                            onChangePagination={this._handleChangePage}
                            onChangeFilter={this._handleChangeFilter}
                            currentPage={currentPage}
                            onChangeNextCurrentPage={this._handleChangeNextCurrentPage}
                            onChangePreCurrentPage={this._handleChangePreCurrentPage}
                        />
                    </CardBody>
                </Card>

                {/* <BackToTop /> */}

                {this._renderModalEdit()}
                {this._renderModalEditProduct()}
                {this._renderModalMarkFaileDesign()}
                {this._renderModalItemLabel()}
                {this._renderModalGenLabelCustomWHL()}
            </div>
        )
    }
}

export default ListItemsPage
